import { Component, OnDestroy, OnInit } from '@angular/core';
import { ShowcaseService } from 'src/app/services/header-showcase/showcase.service';

@Component({
    selector: 'app-strategic-plan',
    templateUrl: './strategic-plan.component.html',
    styleUrls: ['./strategic-plan.component.scss']
})
export class StrategicPlanComponent implements OnInit, OnDestroy {
    src: string = '/assets/pdf/about/Institutional Development Plan.pdf';
    title: string = 'Institutional Development Plan';

    constructor(private showcaseService: ShowcaseService) {
        this.showcaseService.hideShowcase();
    }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
        this.showcaseService.showingShowcase();
    }

}
